import { addWeeks, addMonths, addYears, format } from 'date-fns';

export const calculateNextOccurrence = (lastDate, frequency) => {
  const date = new Date(lastDate);
  switch (frequency) {
    case 'weekly': return format(addWeeks(date, 1), 'yyyy-MM-dd');
    case 'monthly': return format(addMonths(date, 1), 'yyyy-MM-dd');
    case 'quarterly': return format(addMonths(date, 3), 'yyyy-MM-dd');
    case 'annually': return format(addYears(date, 1), 'yyyy-MM-dd');
    default: return format(addMonths(date, 1), 'yyyy-MM-dd');
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'Active': return 'text-emerald-600 bg-emerald-50 border-emerald-100';
    case 'Paused': return 'text-amber-600 bg-amber-50 border-amber-100';
    default: return 'text-slate-400 bg-slate-50 border-slate-100';
  }
};